import React from "react";
import { string, bool } from "prop-types";

import DfpAd from "../../dfp-ad";

import "./topAd.m.css";

const TopAd = ({ showAd, adtype = "Home_728x90_T1", className = "" }) => (
  <div styleName="ad-slot" className={className}>
    <DfpAd adtype={adtype} topAd={true} />
  </div>
);

TopAd.propTypes = {
  showAd: bool,
  adtype: string,
  className: string
};

export default TopAd;
